import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';

import initI18n from './services/i18n';
import { store } from './services/redux';

import { BRAND_NAME } from './config';

const ConnectedApp = React.lazy(() => import('./App'));

const PositionRestore = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.sectionId) {
      setTimeout(() => {
        const element = document.getElementById(location.state.sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 0);
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [location]);

  return null;
};

function Init() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    Promise.all([initI18n(BRAND_NAME)]).then(() => {
      setLoaded(true);
    });
  }, []);

  return loaded ? (
    <React.Suspense fallback={null}>
      <Provider store={store}>
        <BrowserRouter>
          <PositionRestore />
          <React.Fragment>
            <ConnectedApp />
          </React.Fragment>
        </BrowserRouter>
      </Provider>
    </React.Suspense>
  ) : null;
}

if (module.hot) {
  module.hot.accept(render);
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

function render() {
  root.render(<Init />);
}

render();
